var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TextArea_1;
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import BlueprintComponent from '../core/blueprintComponent';
import '../../scss/components/textArea.scss';
/** The name of the module */
export const name = 'TextArea';
/** Classnames for this module */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-textArea";
    ClassNames["JavaScript"] = "js-textArea";
})(ClassNames || (ClassNames = {}));
let TextArea = TextArea_1 = class TextArea extends BlueprintComponent {
    constructor(options) {
        super(name, options);
    }
    /**
      * Create a new instance of this object
      *
      * @param options Data and options to initialize component with
      */
    static create(options) {
        return new TextArea_1(options);
    }
    /**
      * Attach input event onto textarea element
      */
    async init() {
        super.init();
        this.element = await BlueprintComponent.loadElement(name, this.options);
        // Ensure that textArea is always cleared. Fixes issue where if context exists inside
        // of textArea and the page is reloaded, then validation breaks
        this.element.value = '';
        this.element.addEventListener('input', this.resize.bind(this));
    }
    /**
      * Resize element's height to its scrollable height
      *
      * @param event Object based on Event describing the event that has occurred
      */
    resize() {
        // Reset height of element to auto. This is needed to handle the vertical height "shrinking".
        // Without it, the textarea will grow in height vertically as expected but will not shrink.
        this.element.style.height = 'auto';
        this.element.style.height = `${this.element.scrollHeight}px`;
    }
};
TextArea = TextArea_1 = __decorate([
    injectable(name)
], TextArea);
export default TextArea;
/** Create TextArea component in the hydration queue */
BlueprintComponent.instantiate(name);
